<div class="p-24 text-center">
    <div [ngSwitch]="signalRService.statoConnessione$|async">
        <div *ngSwitchCase="SignalrStates.Connected">
            <mat-icon class="green-font-color">wifi </mat-icon>
        </div>
        <div *ngSwitchCase="SignalrStates.Disconnected">
            <mat-icon class="red-font-color">wifi_off </mat-icon>
        </div>
        <div *ngSwitchCase="SignalrStates.Connecting || SignalrStates.Reconnecting ">
            <mat-icon class="yellow-font-color" style="animation: blink 0.5s ease-in infinite;">wifi </mat-icon>
        </div>
        <div *ngSwitchDefault></div>
    </div>
</div>